import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import './WaveformModal.css';

const TEST_MP3 = 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3';

const WaveformModal = ({ open, onClose, songTitle, audioUrl }) => {
  const waveformRef = useRef(null);
  const wavesurfer = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (open) {
      console.log('WaveformModal mounted for:', songTitle);
    }
    if (open && waveformRef.current) {
      wavesurfer.current = WaveSurfer.create({
        container: waveformRef.current,
        waveColor: '#e573e5',
        progressColor: '#e21e26',
        height: 120,
        responsive: true,
      });
      wavesurfer.current.load(audioUrl || TEST_MP3);
      wavesurfer.current.on('finish', () => setIsPlaying(false));
    }
    return () => {
      if (wavesurfer.current) {
        wavesurfer.current.destroy();
        wavesurfer.current = null;
      }
    };
  }, [open, audioUrl, songTitle]);

  const handlePlayPause = () => {
    if (wavesurfer.current) {
      wavesurfer.current.playPause();
      setIsPlaying(wavesurfer.current.isPlaying());
    }
  };

  if (!open) return null;

  return (
    <div className="waveform-modal-overlay" onClick={onClose}>
      <div className="waveform-modal-content" onClick={e => e.stopPropagation()}>
        <button className="waveform-modal-close" onClick={onClose}>×</button>
        <h2 className="waveform-modal-title">{songTitle || 'Song Title'}</h2>
        <div ref={waveformRef} className="waveform-modal-waveform" />
        <div className="waveform-modal-controls">
          <button onClick={handlePlayPause} className="waveform-modal-play">
            {isPlaying ? 'Pause' : 'Play'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WaveformModal; 